import { RootState } from '../../../../../init-store';
import { isMessengerIntegration } from '../../../../shared/features/config/selectors';

export const selectIsCloudRecordingAvailable = (state: RootState) =>
    Boolean(state.call.conference.config?.client_configuration?.cloud_recording_available) &&
    !isMessengerIntegration(state);

export const selectCloudRecordingStatus = (state: RootState) =>
    state.call.cloudRecording.cloudRecordingStatus || state.call.conference.settings?.cloud_recording_status;

export const selectIsCloudRecordingRunning = (state: RootState) => selectCloudRecordingStatus(state) === 'RUNNING';

export const selectIsCloudRecordingStopModalOpened = (state: RootState) => state.call.cloudRecording.isStopModalOpened;
